module.exports = __webpack_public_path__ + "img/regist-success.67ff22af.png";